export class IngotType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const PACKING_LIST = new IngotType('packing_list', '装箱单', 'Packing list')
export const COMMERCIAL_INVOICE = new IngotType('commercial_invoice', '发票', 'Commercial Invoice')
export const HOUSE_BILL_OF_LADING = new IngotType('house_bill_of_lading', '分单HBL', 'House Bill of Lading')
export const BILL_LADING_TELEX = new IngotType('bill_lading_telex', '分单HBL电放', 'Bill Lading Telex')
export const FORWARDER_CERTIFICATE_RECEIPT = new IngotType('forwarder_certificate_receipt', '货代收货证明FCR', 'Forwarder Certificate Receipt')
export const MASTER_BILL_OF_LADING = new IngotType('master_bill_of_lading', '主单MBL', 'Master Bill of Lading')

export const INGOT_TYPES = [PACKING_LIST, COMMERCIAL_INVOICE, HOUSE_BILL_OF_LADING, BILL_LADING_TELEX, FORWARDER_CERTIFICATE_RECEIPT, MASTER_BILL_OF_LADING]

export function inIngotTypeByStr(typeStr) {
  let isOk = false
  for (const c of INGOT_TYPES) {
    if (c.code === typeStr) {
      isOk = true
      break
    }
  }
  return isOk
}

export function inIngotTypeByStrings(typeStr) {
  const types = typeStr.split(',')
  for (const t of types) {
    if (inIngotTypeByStr(t)) {
      return true
    }
  }
  return false
}
